import { render, staticRenderFns } from "./wsqMiddle.vue?vue&type=template&id=2affedc8&scoped=true&"
import script from "./wsqMiddle.vue?vue&type=script&lang=js&"
export * from "./wsqMiddle.vue?vue&type=script&lang=js&"
import style0 from "./wsqMiddle.vue?vue&type=style&index=0&id=2affedc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affedc8",
  null
  
)

export default component.exports